import "./style.css";
import React, { useState, useEffect, useContext } from "react";
import InstagramIcon from "@mui/icons-material/Instagram";
import Logo from "../../../../resources/logo.png";
import { CartContext } from "../../../../context/CartContext";
import { host } from "../../../../config/Config";
import EducationBreadcrumb from "../../../../common/EducationBreadcrumb";

export const HandsOn = () => {
    const phoneNumber = "+381 60-3859-426";
    const { addToCart } = useContext(CartContext);
    const [price, setPrice] = useState(0);
    const [loading, setLoading] = useState(true);
    const [hasAvailableSlots, setHasAvailableSlots] = useState(false);
    const [slotMessage, setSlotMessage] = useState("");
    const [fadeIn, setFadeIn] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);

        // Trigger fade in after a brief delay
        setTimeout(() => {
            setFadeIn(true);
        }, 100);

        // Fetch price from backend
        fetch(`${host}/api/v1/education-prices/type/hands-on`)
            .then((response) => response.json())
            .then((data) => {
                setPrice(data.price);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching price:", error);
                setPrice(50); // fallback price
                setLoading(false);
            });

        // Check slot availability
        fetch(`${host}/api/v1/education-slots/type/hands-on`)
            .then((response) => response.json())
            .then((slots) => {
                const activeSlots = slots.filter(
                    (slot) =>
                        slot.status === "ACTIVE" && slot.availableSlots > 0
                );
                if (activeSlots.length > 0) {
                    setHasAvailableSlots(true);
                    setSlotMessage("");
                } else {
                    setHasAvailableSlots(false);
                    const hasSlots = slots.some(
                        (slot) => slot.status === "ACTIVE"
                    );
                    setSlotMessage(
                        hasSlots
                            ? "Svi termini su trenutno popunjeni. Molimo kontaktirajte nas za više informacija."
                            : "Trenutno nema dostupnih termina za ovu edukaciju. Molimo kontaktirajte nas."
                    );
                }
            })
            .catch((error) => {
                console.error("Error fetching slots:", error);
                setHasAvailableSlots(false);
                setSlotMessage(
                    "Trenutno nema dostupnih termina za ovu edukaciju."
                );
            });
    }, []);

    const HandleOpenMap = () => {
        const url = `https://maps.app.goo.gl/6wxPp2i9rRZ45HQs6`;
        window.open(url, "_blank");
    };

    return (
        <div className='page-handson'>
            <EducationBreadcrumb />

            <div className={`items-handson ${fadeIn ? "fade-in" : ""}`}>
                <h1
                    style={{
                        fontSize: "37px",
                        color: "#be9455",
                        letterSpacing: "1px",
                        textShadow:
                            "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                    }}
                >
                    Hands On
                </h1>
                <h1 style={{ marginTop: "-19px" }}>
                    Edukacija za napredne barbere
                </h1>
                <p>
                    Naša jednodnevna Hands On edukacija namenjena je barberima
                    koji žele da unaprede postojeće veštine i usavrše tehniku
                    rada kroz intenzivnu praksu.
                </p>

                <p
                    style={{
                        textAlign: "center",
                        fontSize: "28px",
                        color: "#be9455",
                        letterSpacing: "1px",
                        textShadow:
                            "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                    }}
                >
                    Program obuke obuhvata
                </p>
                <p style={{ textAlign: "center" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Napredne Fade, klasičnog i usavršenog šišanja, tehnike i
                    perfekcionisanje prelaza
                </p>
                <p style={{ textAlign: "center", marginTop: "-20px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Precizno oblikovanje i definisanje linija
                </p>
                <p style={{ textAlign: "center", marginTop: "-20px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Savremene pristupe stilizovanju i finišing detalje
                </p>
                <p style={{ textAlign: "center", marginTop: "-20px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Efikasno korišćenje alata u radu sa modelima
                </p>

                <img
                    src={Logo}
                    style={{ width: "140px", borderRadius: "8px" }}
                />

                <p style={{ fontSize: "22px" }}>
                    Fokus edukacije je na praktičnom radu koje polaznik
                    individualno prolazi kroz modele pod nadzorom edukatora, uz
                    detaljnu analizu i korekcije. Cilj je da svaki barber stekne
                    još veću sigurnost, brzinu i preciznost i podigne vaše
                    usluge na viši nivo.
                </p>

                <p style={{ textAlign: "center", marginTop: "10px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Ova edukacija je idealna za barbere koji žele da usavrše
                    svoj stil i ponude klijentima vrhunski standard
                </p>

                {!loading && (
                    <div
                        style={{
                            textAlign: "center",
                            fontSize: "32px",
                            fontWeight: "bold",
                            color: "#be9455",
                            marginTop: "30px",
                            marginBottom: "10px",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        Cena: {price.toLocaleString()} EUR
                    </div>
                )}

                <div
                    className={`buy-button-handson ${
                        !hasAvailableSlots ? "disabled" : ""
                    }`}
                    onClick={() => {
                        if (hasAvailableSlots) {
                            addToCart({
                                id: "hands-on",
                                name: "Hands On",
                                price: price,
                                category: "single",
                            });
                        }
                    }}
                    style={{
                        opacity: hasAvailableSlots ? 1 : 0.5,
                        cursor: hasAvailableSlots ? "pointer" : "not-allowed",
                    }}
                >
                    <p>{hasAvailableSlots ? "Dodaj u korpu" : "Nedostupno"}</p>
                </div>
                {slotMessage && (
                    <p
                        style={{
                            color: "#e74c3c",
                            textAlign: "center",
                            marginTop: "10px",
                            fontSize: "19px",
                            fontStyle: "italic",
                        }}
                    >
                        {slotMessage}
                    </p>
                )}
            </div>

            <a
                className='barbershop-zajednica-footer-title-adresa'
                onClick={HandleOpenMap}
                target='_blank'
                rel='noopener noreferrer'
            >
                <div>
                    <h2>Srpskog sovjeta 1a</h2>
                    <h2>11300, Smederevo</h2>
                    <h2> Klikni me</h2>
                </div>
            </a>
            <div className='barbershop-zajednica-footer-title-adresa'>
                <h2>Posetite Instagram</h2>
                <a
                    href='https://www.instagram.com/_zajednica_/'
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{
                        marginTop: "10px",
                        width: "100%",
                        justifyContent: "center",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                        color: "#f3f3f3",
                        textDecoration: "none",
                    }}
                >
                    <InstagramIcon
                        style={{ color: "#f3f3f3", fontSize: "40px" }}
                    />
                </a>
            </div>

            <div className='barbershop-zajednica-footer-title'>
                <h2>Ili nas kontaktirajte</h2>
            </div>
            <div className='barbershop-zajednica-footer-phone'>
                <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
            </div>
        </div>
    );
};
